module.exports = __webpack_public_path__ + "static/img/lab-m-tool.1886ec66.png";